var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 830.402,
    height: 663.833,
    viewBox: "0 0 830.402 663.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00123b;opacity:0.143;}.a,.af,.ag,.ah,.b,.c,.f,.k,.p,.r,.s,.x{fill-rule:evenodd;}.b{fill:url(#a);}.c{fill:#004c34;}.d{fill:#007f40;}.e,.o{fill:#00502f;}.f{fill:url(#b);}.g,.x{fill:none;}.g{stroke:#979797;}.h{fill:#00c078;}.i{fill:#007243;}.j{fill:#004c31;}.k{fill:#65e3b0;}.l{fill:#007e38;}.m{fill:#00b881;}.n{fill:#00bf77;}.o{opacity:0.1;}.p{fill:#013d24;}.q{fill:#00b471;}.r{fill:#004c2d;}.aj,.s,.v{fill:#fff;}.t{fill:#262932;}.u{fill:#17191f;}.w{fill:#171a22;}.y{fill:#30323e;}.z{fill:#89c3ed;}.aa{fill:#37a7fc;}.ab{fill:#94ceff;}.ac{fill:#df7b5a;}.ad{fill:#080809;}.ae{fill:#0090ff;}.af{fill:#00aa6c;}.ag,.ai{fill:#006132;}.ah{fill:#00be79;}.aj{opacity:0.321;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.214,
    y1: 0.095,
    x2: 0.351,
    y2: 0.463,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004a25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#007f40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007f40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00502f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.44 0.268)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M256.018,427.137V295.969h37.943V282.394H312.05V255h10v14h9V252h27v14h13V244h18v29h9V252h26v17h9v25h9V252h60v55h33V273h6V236h6V189l14-16,14,16v47h6v37h6v20h5V214h44V430.381Z",
    transform: "translate(0 -38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M203.05,218l-100,31c15,36,56,105,92,133,14.925,11.608,23.8,15.439,28,12,5.926-4.856,4.706-19.465,17-6,21,23,68,84,124,111s44-33,86,1,59,41,101,54c28,8.667,61.96,10.426,147.96,8.426L722.05,239q-80,89-126,111c-54.739,26.179-108,0-140-12s-15,22-43,15-51-56-69-69c-28.659-20.7-13,20-41,5q-28-15-63-50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M462.55,337a6.5,6.5,0,0,1,6.5,6.5,6.575,6.575,0,0,1-.034.672A12,12,0,1,1,471.05,368c-6.627,0-31.358,10-35.5,10a7.5,7.5,0,1,1,1.057-14.926,7.5,7.5,0,0,1,.855-10.084,5,5,0,0,1,7.607-5.975,6.5,6.5,0,0,1,11.015-4.172A6.5,6.5,0,0,1,462.55,337Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M585.55,352a6.5,6.5,0,0,1,6.5,6.5,6.575,6.575,0,0,1-.034.672A12,12,0,1,1,594.05,383c-6.627,0-31.358,10-35.5,10a7.5,7.5,0,1,1,1.057-14.926,7.5,7.5,0,0,1,.855-10.084,5,5,0,0,1,7.607-5.975,6.5,6.5,0,0,1,11.015-4.172A6.5,6.5,0,0,1,585.55,352Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M294.45,380a7.772,7.772,0,0,1,7.759,8.572,14.348,14.348,0,1,1,2.441,28.477c-7.953,0-37.629,11.951-42.6,11.951a8.963,8.963,0,1,1,0-17.927,9.115,9.115,0,0,1,1.268.088,8.935,8.935,0,0,1,1.026-12.052,5.922,5.922,0,0,1-.495-2.378,6.005,6.005,0,0,1,9.623-4.764,7.808,7.808,0,0,1,13.217-4.986A7.787,7.787,0,0,1,294.45,380Z",
    transform: "translate(-202.245 320.744) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.05 279.004)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 76,
    height: 83,
    rx: 3,
    transform: "translate(165 78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 33,
    height: 187,
    transform: "translate(263 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 79,
    height: 106,
    transform: "translate(293 57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 83,
    height: 4,
    transform: "translate(289 53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M308,131v15h-7V131Zm12,0v15h-7V131Zm12,0v15h-7V131Zm12,0v15h-7V131Zm12,0v15h-7V131Zm12,0v15h-7V131Zm-60-21v15h-7V110Zm12,0v15h-7V110Zm12,0v15h-7V110Zm12,0v15h-7V110Zm12,0v15h-7V110Zm12,0v15h-7V110ZM308,89v15h-7V89Zm12,0v15h-7V89Zm12,0v15h-7V89Zm12,0v15h-7V89Zm12,0v15h-7V89Zm12,0v15h-7V89ZM308,68V83h-7V68Zm12,0V83h-7V68Zm12,0V83h-7V68Zm12,0V83h-7V68Zm12,0V83h-7V68Zm12,0V83h-7V68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 4,
    height: 15,
    transform: "translate(279 136)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 41,
    height: 127,
    transform: "translate(130 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 70,
    height: 239,
    rx: 3,
    transform: "translate(62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M81,139v16H74V139Zm13,0v16H87V139Zm13,0v16h-7V139Zm13,0v16h-7V139ZM81,114v16H74V114Zm13,0v16H87V114Zm13,0v16h-7V114Zm13,0v16h-7V114ZM81,89v16H74V89Zm13,0v16H87V89Zm13,0v16h-7V89Zm13,0v16h-7V89ZM81,64V80H74V64Zm13,0V80H87V64Zm13,0V80h-7V64Zm13,0V80h-7V64ZM81,39V55H74V39Zm13,0V55H87V39Zm13,0V55h-7V39Zm13,0V55h-7V39ZM81,14V30H74V14Zm13,0V30H87V14Zm13,0V30h-7V14Zm13,0V30h-7V14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 66,
    height: 148,
    rx: 4,
    transform: "translate(0 68)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 71,
    height: 11,
    transform: "translate(582.05 417.004)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 124,
    height: 133,
    transform: "translate(554.05 431.004)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(439.05 380.004)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 115,
    height: 179
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 115,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 115,
    height: 3,
    transform: "translate(0 9)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 28)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 16,
    height: 24,
    transform: "translate(4 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M22,0V28H2V0ZM19,15H5V25H19ZM19,3H5V13H19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 24,
    height: 3,
    transform: "translate(0 29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 20,
    height: 1,
    transform: "translate(2 28)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 73)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 16,
    height: 24,
    transform: "translate(4 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M22,0V28H2V0ZM19,15H5V25H19ZM19,3H5V13H19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 24,
    height: 3,
    transform: "translate(0 29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 20,
    height: 1,
    transform: "translate(2 28)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46 28)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 16,
    height: 24,
    transform: "translate(4 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M22,0V28H2V0ZM19,15H5V25H19ZM19,3H5V13H19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 24,
    height: 3,
    transform: "translate(0 29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 20,
    height: 1,
    transform: "translate(2 28)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46 73)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 16,
    height: 24,
    transform: "translate(4 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M22,0V28H2V0ZM19,15H5V25H19ZM19,3H5V13H19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 24,
    height: 3,
    transform: "translate(0 29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 20,
    height: 1,
    transform: "translate(2 28)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78 28)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 16,
    height: 24,
    transform: "translate(4 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M22,0V28H2V0ZM19,15H5V25H19ZM19,3H5V13H19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 24,
    height: 3,
    transform: "translate(0 29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 20,
    height: 1,
    transform: "translate(2 28)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78 73)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 16,
    height: 24,
    transform: "translate(4 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M22,0V28H2V0ZM19,15H5V25H19ZM19,3H5V13H19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 24,
    height: 3,
    transform: "translate(0 29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 20,
    height: 1,
    transform: "translate(2 28)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.05 425.004)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 130,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 121,
    height: 142,
    transform: "translate(6 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 124,
    height: 15,
    transform: "translate(6 9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M0,6H130l6,3H6Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30 18)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M9,1A7.36,7.36,0,0,0,1.64,8.36V24H16.36V8.36A7.36,7.36,0,0,0,9,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M0,25V23H1V8A8,8,0,0,1,8.751,0L9,0a8,8,0,0,1,8,8h0V23h1v2ZM8,2.083A6,6,0,0,0,3,8H3V23H8Zm2,0V23h5V8A6,6,0,0,0,10,2.083Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30 55)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M9,1A7.36,7.36,0,0,0,1.64,8.36V24H16.36V8.36A7.36,7.36,0,0,0,9,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M0,25V23H1V8A8,8,0,0,1,8.751,0L9,0a8,8,0,0,1,8,8h0V23h1v2ZM8,2.083A6,6,0,0,0,3,8H3V23H8Zm2,0V23h5V8A6,6,0,0,0,10,2.083Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63 18)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M9,1A7.36,7.36,0,0,0,1.64,8.36V24H16.36V8.36A7.36,7.36,0,0,0,9,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M0,25V23H1V8A8,8,0,0,1,8.751,0L9,0a8,8,0,0,1,8,8h0V23h1v2ZM8,2.083A6,6,0,0,0,3,8H3V23H8Zm2,0V23h5V8A6,6,0,0,0,10,2.083Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63 55)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M9,1A7.36,7.36,0,0,0,1.64,8.36V24H16.36V8.36A7.36,7.36,0,0,0,9,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M0,25V23H1V8A8,8,0,0,1,8.751,0L9,0a8,8,0,0,1,8,8h0V23h1v2ZM8,2.083A6,6,0,0,0,3,8H3V23H8Zm2,0V23h5V8A6,6,0,0,0,10,2.083Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30 92)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M9,1A7.36,7.36,0,0,0,1.64,8.36V24H16.36V8.36A7.36,7.36,0,0,0,9,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M0,25V23H1V8A8,8,0,0,1,8.751,0L9,0a8,8,0,0,1,8,8h0V23h1v2ZM8,2.083A6,6,0,0,0,3,8H3V23H8Zm2,0V23h5V8A6,6,0,0,0,10,2.083Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63 92)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M9,1A7.36,7.36,0,0,0,1.64,8.36V24H16.36V8.36A7.36,7.36,0,0,0,9,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M0,25V23H1V8A8,8,0,0,1,8.751,0L9,0a8,8,0,0,1,8,8h0V23h1v2ZM8,2.083A6,6,0,0,0,3,8H3V23H8Zm2,0V23h5V8A6,6,0,0,0,10,2.083Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385.05 415.004)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 54,
    height: 106,
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 2,
    height: 106,
    transform: "translate(52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 54,
    height: 2,
    transform: "translate(0 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 54,
    height: 2,
    transform: "translate(0 11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 9,
    height: 20,
    transform: "translate(11 22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 9,
    height: 20,
    transform: "translate(11 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 9,
    height: 20,
    transform: "translate(24 22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 9,
    height: 20,
    transform: "translate(24 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 9,
    height: 20,
    transform: "translate(37 22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 9,
    height: 20,
    transform: "translate(37 50)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(471.05 458.004)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M79,0A21.009,21.009,0,0,1,99.191,15.206,30.437,30.437,0,0,1,110,38.5q0,1.142-.083,2.263A22.009,22.009,0,0,1,82,72.081V104H74V68.506A30.273,30.273,0,0,1,67.3,66.46,18,18,0,0,1,49.133,35.649a30.409,30.409,0,0,1,9.379-19.28A21.008,21.008,0,0,1,79,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M26.577,29a15.091,15.091,0,0,1,14.5,10.923,21.863,21.863,0,0,1,7.765,16.732q0,.82-.059,1.625a15.809,15.809,0,0,1-20.054,22.5V103.7H22.986v-25.5a21.746,21.746,0,0,1-4.817-1.469A12.932,12.932,0,0,1,5.124,54.607a21.843,21.843,0,0,1,6.737-13.849A15.09,15.09,0,0,1,26.577,29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M103.05,249c15,36,56,105,92,133,14.925,11.608,23.8,15.439,28,12,5.926-4.856,4.706-19.465,17-6,21,23,68,84,124,111s44-33,86,1,59,41,101,54q42,13,171,10v13h-619Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(616.05)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M80.912,653.035v7.519s-8.23,3.694-16.013,2.9-15.038-5.012-16.226-6.2-4.749-4.221-11.74-4.221-14.425-5.277-15.985-8.311.3-9.377.3-9.377l23.331,1.99,33.507,13.192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M80.912,639.988s1.9,10.409,0,13.047c0,0-12.056,5.409-22.213,1.715s-11.74-6.611-20.051-6.735-15.83-4.61-17.413-9.359,3.694-7.783,8.311-7.519,7.783,1.187,10.025.66a5.629,5.629,0,0,0,3.216-1.908l19.869-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M6.514,366.409l-2.921,7.7L2,379.683V387l18,7,6-4,2.023-7.931-2.655-9.029,1.723-6.635L19.526,351l-10.74,3.608Z",
    transform: "translate(-19.475 1.296) rotate(-3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M153.018,648.946v5.807a2.674,2.674,0,0,1-1.652,2.475,21.541,21.541,0,0,1-10.484,1.743c-5.013-.659-9.234-.536-13.587-4.951s-3.957-6.13-9.1-8.24-5.289-4.222-5.283-8.707,9.24,1.188,9.24,1.188l27.834,8.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M152.279,632.6s2.454,11.466.739,16.347c0,0-10.157,4.353-17.808,2.506s-6.86-5.145-9.762-6.068a71.952,71.952,0,0,1-10.949-5.4c-2.242-1.6-2.374-5.949,1.319-6.74s4.892-2.573,4.892-2.573l12.841-3.891Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M92.172,360.017l-.764.047S91.686,360.062,92.172,360.017Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M91.409,360.064l.763-.047q.251-.022.57-.063Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M92.742,359.954q-.32.041-.57.063l37.069-2.272h-9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M91.408,360.064s.279,0,.764-.047l-.763.047Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M91.408,360.064Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M92.172,360.017l-.764.047S91.686,360.062,92.172,360.017Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M176.646,289.28l-16.079,9.313L148,290.836,162.323,274h18.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M92.172,360.017l-.764.047S91.686,360.062,92.172,360.017Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M86.615,383.4h30.8l-30.8,13.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M33-350h67L88.16-634.158a6,6,0,0,0-3.723-5.3l-11.12-4.549A21.324,21.324,0,0,0,58.5-644.5l-3.658,1.219a6,6,0,0,0-4.091,5.323L33-350Z",
    transform: "translate(133) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.998, -0.07, 0.07, 0.998, -6.164, 9.405)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M109.941,72.957l-2.141-.51s-1.164-11.043,3.775-28.206L96.438,38.919,73.756,24.4c-2.446,2.121-3.588,19.409-3.588,19.409v4.043l1.607,5.219s-1.607,8.318-1.607,9.3,1.231,13.02,2.372,19.87,5.783,9.2,7.414,9.358a4.708,4.708,0,0,0,2.311-.618c-.051,2.881-.354,5.674-.354,5.674l1.468,1.358L113.2,90.054a27.732,27.732,0,0,0-1.839-3.288C108.963,83.877,109.941,72.957,109.941,72.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M121.87,70.723c1.794-5.383-7.34-25.443-7.34-25.443l-2.955-1.039C106.636,61.4,107.8,72.447,107.8,72.447l2.141.51s-.978,10.92,1.422,13.809a27.732,27.732,0,0,1,1.837,3.288l9.5-2.536S120.076,76.1,121.87,70.723Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M114.1,36.476C121.892,15.061,100.054.161,99.828,0,79.649-.224,73.893,9.529,72.477,15.827c-1.221,5.428,2.911,13.306,2.911,13.306-2.936,3.425-2.447,14.026-2.284,16.962S76.04,58,76.04,58l2.936.326s-.327-10.6,5.708-9.785,6.2,13.373,7.339,16.309a7.952,7.952,0,0,0,4.415,4.077c3.1,1.949,7.263,2.987,11.362,3.519C107.8,72.447,106.276,58,114.1,36.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M119.262,72.9A4.464,4.464,0,0,0,123.33,69.8a29.5,29.5,0,0,1,6.042-10.009c6.524-7.5,9.508-20.854,9.345-30.151S129.535,2.386,105.071.265C103.219.1,101.481.027,99.828,0c.226.153,22.064,15.053,14.276,36.468-7.828,21.526-6.3,35.971-6.3,35.971a70.875,70.875,0,0,0,11.458.455Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M77.293,58.14S75.714,46.748,79.3,46.095s8.644,4.519,6.034,12.045S81.5,68.928,81.5,68.928Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M75,361l85-11-2.951,282.265a7,7,0,0,1-4.462,6.451L148,640.5a21.783,21.783,0,0,1-17.637-.819l-7.863-3.931a7,7,0,0,1-3.843-5.648L96.751,380.927A21.835,21.835,0,0,0,75,361Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M134.44,98.013,123.608,87.644a82.667,82.667,0,0,0-12.245-.878l-3.009,2.072s1.468,5.086,2.332,10.084c.16,4.437,6.675,5.694,9.538,9.018L134.44,105.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M94,372a14.649,14.649,0,0,0,12.44,9.944L117,383h0l-22,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M111.363,86.766c-.484.013-.962.032-1.422.065-5.655.406-20.706,2.237-24.774,4.474s-13.392,14.914-13.392,14.914l24.782,6.442,23.667-4.721a64.293,64.293,0,0,0-9.538-9.018C119.2,98.38,111.363,86.766,111.363,86.766Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M130.174,125.962c-.941-14.36-18.238-27.04-18.238-27.04h-1.249c-1.233.074-2.465.153-3.683.238-12.94.9-28.255,3.439-28.255,3.439l-4.563,2.5L33.459,123.948,33.1,133.4l8.339,25.016-1.73,206.644,17.41-1.846h0l25.4-2.425,8.885-.732h0l1.333-.11c5.283-.675,25.5-5.517,20.958-40.263C104.357,248.3,133.836,181.793,130.174,125.962Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M59.646,251.536,56,185,41.439,158.423,52,161l-4.053,71.452L31.676,320.932,32,341l1,24h9.72a10,10,0,0,0,9.972-9.254l6.825-91.286A100,100,0,0,0,59.646,251.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M189.069,120.857c-4.994-8.893-47.5-20.059-47.5-20.059l-7.125-2.785s-11.895.2-23.753.909h0s17.3,12.68,18.238,27.04c3.662,55.831-25.817,122.339-16.474,193.729,4.545,34.746-14.43,39.588-19.713,40.263,0,0,80.8-.38,85.171-19.09h0L159.2,291.034c3.806-33.092,16.261-80.618,25.017-97.831h0c5.288-6.915,6.559-14.521,7.322-17.084C194.108,167.5,194.064,129.751,189.069,120.857Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M186.266,120.477l47.107,69.839a20,20,0,0,1,0,22.368L182.006,288.84a3,3,0,0,1-4.165.81h0L153.8,273.433a3,3,0,0,1-.81-4.165l42.693-63.3h0L153.1,142.845Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M24.016,123.546l22.15-2.241h0L55.2,247.234,44.39,362.95a5,5,0,0,1-5.4,4.517l-17.775-1.519a4,4,0,0,1-3.659-3.988l.17-231.454A7,7,0,0,1,24.016,123.546Z",
    transform: "translate(25.767 -2.462) rotate(6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.344 47.389) rotate(8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M55.9,14l104.7,11.213Q136.372,125.774,160.979,235l-97.161-.172Q37.144,121.821,55.9,14Z",
    transform: "translate(-48.24 68.964) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M63.168,20.794,155.6,30.012q-21.991,95.622.354,199.477l-88.2-.156Q44.111,108.006,63.168,20.794Z",
    transform: "translate(-48.463 69.419) rotate(-30)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.088 47.486) rotate(7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M60.553,13.965,158.539,24.8q-24.024,101.508,1.755,212.1L61.33,236.08Q35.7,111.244,60.553,13.965Z",
    transform: "translate(-48.74 68.957) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M65.246,20.663,154.2,30.928q-21.772,96.527,1.669,201.668l-89.835-.736Q42.722,113.168,65.246,20.663Z",
    transform: "translate(-49.244 69.476) rotate(-30)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.146 44.534) rotate(4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M67.814,10.1,114.807,41.45Q88.153,151.013,157.82,249.12l-91.543.156Q40.324,115.122,67.814,10.1Z",
    transform: "translate(-50.678 70.249) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M70.724,12.83l94.582,10.107q-24.2,104.174-.37,217.143l-95.625.163Q45.762,112.682,70.724,12.83Z",
    transform: "translate(-48.318 72.749) rotate(-30)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.444 34.742)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M68.605,15l108.82,11.254q-27.639,114.135,0,238h-110Q40.086,124.4,68.605,15Z",
    transform: "translate(-54.308 76.574) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M72.65,21.541l98.782,10.7q-25.089,108.524,0,226.3H71.579Q46.761,125.559,72.65,21.541Z",
    transform: "translate(-54.555 76.478) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M78,29.541l86.435,9.979q-21.953,101.2,0,211.021H77.06Q55.345,126.537,78,29.541Z",
    transform: "translate(-54.555 76.478) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "ai",
    cx: 26.5,
    cy: 34,
    rx: 26.5,
    ry: 34,
    transform: "translate(75.059 122.999) rotate(-27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M213.123,202.467l-24.073-7.785a21.507,21.507,0,0,0,13.8,33.007Z",
    transform: "translate(162.193 -76.808) rotate(36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M152.6,237.14l-24.366-7.783a21.21,21.21,0,0,0-3.634,11.9,21.573,21.573,0,0,0,17.6,21.1Z",
    transform: "matrix(-0.574, 0.819, -0.819, -0.574, 419.489, 273.342)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M106.495,23.916l-20.1,11.643a19.747,19.747,0,0,0,31,10.862Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M36.405,52.013,17,64.531a16.074,16.074,0,0,0,5.217,8.886c7.143,6.432,20.047,5.546,27.443-.037Z",
    transform: "translate(-38.943 75.326) rotate(-71)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M2074.232,20723a1,1,0,1,1,1,1A1,1,0,0,1,2074.232,20723Zm-24-12a1,1,0,1,1,1,1A1,1,0,0,1,2050.234,20711Zm25-3.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,2075.236,20707.5Zm-30-11a.5.5,0,1,1,.5.5A.5.5,0,0,1,2045.231,20696.5Zm27-7.5a1,1,0,1,1,1,1A1,1,0,0,1,2072.235,20689Zm27-4a1,1,0,1,1,1,1A1,1,0,0,1,2099.233,20685Zm-108-3a2,2,0,1,1,2,2A2,2,0,0,1,1991.234,20682Zm130-2a1,1,0,1,1,1,1A1,1,0,0,1,2121.234,20680Zm-37-5a2,2,0,1,1,2,2A2,2,0,0,1,2084.233,20675Zm-18,1.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,2066.233,20676.5Zm-23-.5a1,1,0,1,1,1,1A1,1,0,0,1,2043.234,20676Zm-12-3a1,1,0,1,1,1,1A1,1,0,0,1,2031.235,20673Zm101-9a1,1,0,1,1,1,1A1,1,0,0,1,2132.234,20664Zm-32-3a1,1,0,1,1,1,1A1,1,0,0,1,2100.232,20661Zm-86-1a2,2,0,1,1,2,2A2,2,0,0,1,2014.233,20660Zm105-1.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,2119.231,20658.5Zm18-7a.5.5,0,1,1,.5.5A.5.5,0,0,1,2137.232,20651.5Zm-71-1.5a1,1,0,1,1,1,1A1,1,0,0,1,2066.233,20650Zm-26-1a2,2,0,1,1,2,2A2,2,0,0,1,2040.233,20649Zm13,.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,2053.235,20649.5Zm27-3.5a1,1,0,1,1,1,1A1,1,0,0,1,2080.234,20646Zm-66-1.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,2014.233,20644.5Zm117-5.5a1,1,0,1,1,1,1A1,1,0,0,1,2131.235,20639Zm-98-.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,2033.232,20638.5Zm26-8.5a1,1,0,1,1,1,1A1,1,0,0,1,2059.232,20630Zm-12-4a1,1,0,1,1,1,1A1,1,0,0,1,2047.233,20626Z",
    transform: "translate(-1799 -20354)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManMoney);
export default __webpack_public_path__ + "static/media/man-money.ed8d6111b474b9a935fdef1279d0356c.svg";
export { ForwardRef as ReactComponent };